<template>
    <div class="materialList">
        <div class="materialList__needs" v-if="construction.hints">
            <calculation-hint :hint="hint" :key="hint.id" v-for="hint in construction.hints"/>
        </div>
        <div v-for="value in calculatedConstructionMaterial">
            <div class="materialList__header">
                <div class="materialList__construction"><strong>{{value.name}}</strong></div>
            </div>
            <div class="materialList__item" v-for="product in value.products">
                <div class="materialList__itemImage">
                    <img v-if="product.preview" :src="product.preview"/>
                </div>
                <div class="materialList__itemName" v-html="$options.filters.supCharacter(product.name)"/>
                <div class="materialList__itemValue">
                    <strong>{{product.consumption}}</strong> {{product.units}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import CalculationHint from '../hint/Hint';

    export default {
        name: 'CalculationConstructionMaterialList',
        components: {
            CalculationHint
        },
        computed: {
            ...mapGetters('calculation', ['calculatedConstructionMaterial', 'construction'])
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/material/ConstructionMaterialList.vue